import { combineReducers } from "redux";
import { personalDataForm } from "./personalDataForm";
import { supplyAddressForm } from "./supplyAddressForm";
import { offer } from "./offer";
import { provincesReducer } from "./provinces";
import { supplierEnergyReducer, supplierGasReducer } from "./suppliers";
import { consumptionReducer } from "./consumption";
import { powerReducer } from "./power";
import { consentFormReducer } from "./consentForm";
import { paymentRecapReducer } from "./paymentRecap";
import { callMeBackReducer } from "./callMeBack";
import { globalFormFieldsReducer } from "./globalFormFields";
import { recapReducer } from "./recapReducer";
import { blockingPopupReducer } from "./blockingPopup";
import { textsReducer } from "./textsReducer";
import { pdrPodBlockPopupTimeGateReducer } from "./pdrPodBlockPopupTimeGate";
import changeOfferType from "./changeOfferType";

export const rootReducer = combineReducers({
    personalDataForm,
    supplyAddressForm,
    provinces: provincesReducer,
    offer,
    supplierEnergyReducer,
    supplierGasReducer,
    consumptionReducer,
    powerReducer,
    consentFormReducer,
    paymentRecapReducer,
    callMeBackReducer,
    globalFormFieldsReducer,
    recapReducer,
    blockingPopupReducer,
    textsReducer,
    pdrPodBlockPopupTimeGateReducer,
    changeOfferTypeState: changeOfferType,
});